import React from 'react';

const ImageModal = ({ image, setShowModal }) => {
  return (
    <div className='w-full h-full fixed top-0 left-0 z-50 bg-gray-900 bg-opacity-60 flex items-center justify-center'>
      <div className='relative md:max-w-[1200px] bg-white rounded-[8px] p-5 flex flex-col items-end border-2 border-[#C0392B]'>
        <div className="relative">
          <img className='rounded-[8px] h-full w-full object-cover' src={image.img} alt="Enlarged" />
        </div>
        <button 
          onClick={() => setShowModal(false)} 
          className="w-[2.5rem] bg-[#C0392B] rounded-md p-2 absolute top-0 right-0 m-4 text-white hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        >
          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
